import Shepherd from 'shepherd.js';

if(($('.user-editor').length) || ($('.profile-application-editor').length)){

    if(!$('.profile-application-editor').length){
        ['close', 'cancel', 'complete'].forEach(event => Shepherd.on(event, () => {
            var data = {
                'page': 'profile-editor'
            };
            axios.post("/api/v1/onboarding", data)
            .then((response) =>  {
            }).catch(function (error) {
                console.log('onboarding logged')
            });
        }));
    }else{
        ['close', 'cancel', 'complete'].forEach(event => Shepherd.on(event, () => {
            var data = {
                'page': 'profile-application-editor'
            };
            axios.post("/api/v1/onboarding", data)
            .then((response) =>  {
            }).catch(function (error) {
                console.log('onboarding logged')
            });
            var data = {
                'page': 'profile-editor'
            };
            axios.post("/api/v1/onboarding", data)
            .then((response) =>  {
            }).catch(function (error) {
                console.log('onboarding logged')
            });
        }));
    }
    
    const tour = new Shepherd.Tour({
        defaultStepOptions: {
            cancelIcon: {
                enabled: true
            },
            classes: 'shepherd-container',
            scrollTo: { behavior: 'smooth', block: 'center' }
        },
        useModalOverlay: true
    });
    
    if(!$('.profile-application-editor').length){
        tour.addStep({
            title: 'The Profile Editor',
            text: "Welcome to the Profile Editor. This will show you how your profile looks whilst you live edit it. You can also manage your password and notifications settings here.",
            buttons: [
                {
                    action() {
                        return this.next();
                    },
                    classes: 'btn btn--secondary',
                    text: 'Next'
                }
            ],
            id: 'step-1'
        });
    }else{
        tour.addStep({
            title: 'Start your application',
            text: "To start your application to this Challenge, you need to ensure your innovation or expertise profile is 100% complete on the Visual Editor. Radial progress bars will show you how close you are to completing the form and each individual section that contains required fields.",
            buttons: [
                {
                    action() {
                        return this.next();
                    },
                    classes: 'btn btn--secondary',
                    text: 'Next'
                }
            ],
            id: 'step-1'
        });
    }
    
    tour.addStep({
        title: 'Toggle between views',
        text: "Using these two toggles, you can switch the view mode between a full view of your profile and the editor form.",
        attachTo: {
            element: '#editor-header .middle',
            on: 'bottom'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-2'
    });
    
    tour.addStep({
        title: 'Checking your progress',
        text: "This shows the percentage of your profile progress completion. Once your profile is 100% complete you will be able to apply to Challenges as an expert.",
        attachTo: {
            element: '.radial-progress',
            on: 'bottom'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-3'
    });
    
    tour.addStep({
        title: 'Your basic details',
        text: "These are the fields that you filled in during registration, your name and where you work. You can also change your password in this section. In addition we'd also love it if you could indicate where you found out about us!",
        attachTo: {
            element: '.editor-section#profile-details',
            on: $(window).width() < 992 ? 'top' : 'right'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-4'
    });
    
    tour.addStep({
        title: 'Tell us about your expertise',
        text: "To complete your profile and become a full Member on LEO, you'll need to fill in this section and tell us a bit more about yourself. Once you've completed this you'll be able to apply as an expert to Challenges.",
        attachTo: {
            element: '.editor-section#additional-details',
            on: 'top'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-5'
    });
    
    tour.addStep({
        title: 'Making it visual',
        text: "Make your profile stand out by adding your profile photo, banner and company logo. If your profile is set to private, your company logo will appear instead of your profile photo. They must be jpg format and under 2Mb. Don't worry if you don't have any images, as we'll select a default one for you.",
        attachTo: {
            element: '.editor-section#media',
            on: 'top'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-6'
    });
    
    tour.addStep({
        title: 'Managing your settings',
        text: "In this section, you'll be able to manage your platform notications as well as opt in to our marketing emails if you haven't already. You can also toggle your account on as private, allowing you to remain anonymous and appear as a company rather than as a person.",
        attachTo: {
            element: '.editor-section#account-settings',
            on: 'top'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-7'
    });
    
    
    if(!$('.profile-application-editor').length){
        tour.addStep({
            title: 'Saving or Skipping',
            text: "Once you're finished editing your profile click this save button. You can also click skip to go straight to your dashboard without saving.",
            attachTo: {
                element: '#editor-header .right',
                on: 'bottom'
            },
            buttons: [
                {
                    action() {
                        return this.back();
                    },
                    classes: 'btn btn--border',
                    text: 'Back'
                },
                {
                    action() {
                        return this.next();
                    },
                    classes: 'btn btn--secondary',
                    text: 'Next'
                }
            ],
            id: 'step-8'
        });
    }else{
        tour.addStep({
            title: 'Continuing your application',
            text: "Once you're at 100% on your progress with this form, you can click 'Save and Continue'. If you are applying with an innovation, this will publish it as well if it is still in draft. If you are not finished yet, you can click 'Save'. After clicking 'Save and Continue' your application will be created in a draft state and you will be taken to the vetting page.",
            attachTo: {
                element: '#editor-header .right',
                on: 'bottom'
            },
            buttons: [
                {
                    action() {
                        return this.back();
                    },
                    classes: 'btn btn--border',
                    text: 'Back'
                },
                {
                    action() {
                        return this.next();
                    },
                    classes: 'btn btn--secondary',
                    text: 'Next'
                }
            ],
            id: 'step-7'
        });
    }
    
    if(!$('.profile-application-editor').length){
        tour.addStep({
            title: "Once you're finished",
            text: "When you are finished in the editor, you can click this button to go back to your dashboard or the previous page. Make sure you've saved your profile first though!",
            attachTo: {
                element: '#editor-header .left',
                on: 'bottom'
            },
            buttons: [
                {
                    action() {
                        return this.back();
                    },
                    classes: 'btn btn--border',
                    text: 'Back'
                },
                {
                    action() {
                        return this.complete();
                    },
                    classes: 'btn btn--secondary',
                    text: 'Finish'
                }
            ],
            id: 'step-9'
        });
    }else{
        tour.addStep({
            title: "Dont want to continue?",
            text: "If you dont want to continue your application or you want to come back to it later you can go back to the dashboard here.",
            attachTo: {
                element: '#editor-header .left',
                on: 'bottom'
            },
            buttons: [
                {
                    action() {
                        return this.back();
                    },
                    classes: 'btn btn--border',
                    text: 'Back'
                },
                {
                    action() {
                        return this.complete();
                    },
                    classes: 'btn btn--secondary',
                    text: 'Finish'
                }
            ],
            id: 'step-8'
        });
    }

    $('.replay-onboarding').show();

    $('.replay-onboarding').click(function(){
        tour.start();
    });

    if(($('.user-editor').length && !$('.onboarding-profile-editor').length) || ($('.profile-application-editor').length && !$('.onboarding-profile-application-editor').length)){
        tour.start();
    }
}
